import React, { useEffect, useState } from "react";
import Layout from "./Layout";
import { COLLECTION, SESSION } from "../../../data/constant";
import { db } from "../../../config/firebase";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
} from "firebase/firestore";

import UserViewDisputeModal from "./UserViewDisputeModal";
import UserRaiseDisputeModal from "./UserRaiseDisputeModal";

const UserTransaction = () => {
  const [tableData, setTableData] = useState([]);
  const [isTableLoading, setIsTableLoading] = useState(false);

  // ⭐ MODAL STATES
  const [openRaise, setOpenRaise] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchTransactions = async () => {
      setIsTableLoading(true);
      try {
        const sessionId = localStorage.getItem(SESSION.USER_SESSION_ID);
        if (!sessionId) return;

        const sessionDocRef = doc(db, COLLECTION.USER_SESSION, sessionId);
        const sessionSnap = await getDoc(sessionDocRef);

        let phoneNumber = "";

        if (sessionSnap.exists()) {
          const s = sessionSnap.data();

          if (s.userID) {
            const userDocRef = doc(db, COLLECTION.USER, s.userID);
            const u = await getDoc(userDocRef);
            if (u.exists()) phoneNumber = String(u.data().phoneNumber || "");
          } else {
            phoneNumber = String(s.phoneNumber || "");
          }
        }

        if (!phoneNumber) return;

        const walletRef = collection(db, COLLECTION.WALLET_DEDUCTIONS);
        const q = query(
          walletRef,
          where("phoneNumber", "==", phoneNumber),
          orderBy("Timestamp", "desc")
        );

        const snapshot = await getDocs(q);

        const walletData = await Promise.all(
          snapshot.docs.map(async (docSnap) => {
            const walletDoc = { id: docSnap.id, ...docSnap.data() };

            if (walletDoc.transactionid) {
              const tRef = doc(db, COLLECTION.TRANSACTIONS, walletDoc.transactionid);
              const tSnap = await getDoc(tRef);
              if (tSnap.exists()) {
                walletDoc.transactionTime = tSnap.data().transactionTime;
              }
            }

            return walletDoc;
          })
        );

        if (isMounted) setTableData(walletData);
      } catch (error) {
        console.error("Error fetching WALLET_DEDUCTIONS:", error);
      } finally {
        if (isMounted) setIsTableLoading(false);
      }
    };

    fetchTransactions();

    return () => {
      isMounted = false;
    };
  }, []);

  // ⭐ ACTION BUTTONS — NOW OPEN MODALS CORRECTLY
  const actions = [
    {
      label: "Raise",
      bgColor: "#ff9800",
      onClick: (row) => {
        setSelectedTransaction(row);
        setOpenRaise(true);
      },
    },
    {
      label: "View",
      bgColor: "green",
      onClick: (row) => {
        setSelectedTransaction(row);
        setOpenView(true);
      },
    },
  ];

  return (
    <>
      <Layout
        userTransactionData={tableData}
        isTableLoading={isTableLoading}
        currentPage={1}
        totalLength={tableData.length}
        handlePageChange={() => {}}
        handlePageSize={() => {}}
        handleSearchQuery={() => {}}
        handleTableSorting={() => {}}
        actions={actions}  // PASS ACTIONS HERE
      />

      {/* ⭐ ATTACH BOTH MODALS HERE (GLOBAL SO THEY ALWAYS OPEN) */}
      <UserRaiseDisputeModal
        open={openRaise}
        onClose={() => setOpenRaise(false)}
        transaction={selectedTransaction}
      />

      <UserViewDisputeModal
        open={openView}
        onClose={() => setOpenView(false)}
        transaction={selectedTransaction}
      />
    </>
  );
};

export default UserTransaction;
